// Module
var code = "<react-component name=\"StripePayers\"></react-component>\n";
// Exports
module.exports = code;